import { defineMessages } from 'react-intl'

export default defineMessages({
  editingBadge: {
    id: 'editExpenseReportPresenter.editingBadge',
    defaultMessage: 'Editing',
  },
  successTitle: {
    id: 'editExpenseReportPresenter.successTitle',
    defaultMessage: 'Expense report updated',
  },
  errorTitle: {
    id: 'editExpenseReportPresenter.errorTitle',
    defaultMessage: "Expense report couldn't be updated",
  },
})
